import React from "react";
import _ from "lodash";
import { compose } from "recompose";
import { MessageDescriptor } from "react-intl";

import { Localisation } from "@localisation/index";
import { withLocale, InjectedLocaleProps } from "@localisation/components/withLocale";
import { Select, SelectProps } from "@ui/Select";
import { withTypes, InjectedTypesProps } from "@deliveries/components/withTypes";
import { Type } from "../../models";

type Props = InjectedLocaleProps & InjectedTypesProps;

interface OuterProps {
    selected: string | string[];
    multiple?: boolean;
    placeholder?: string;
    placeholderMessage?: MessageDescriptor;
    onChange?: (code: string | string[]) => void;
    id?: string;
}

type SelectType = typeof Select<Type>;
const SelectType = Select as SelectType;

class TypeSelect extends React.Component<Props & OuterProps> {
    private handleChange(option: Type | Type[]) {
        const { onChange } = this.props;
        if (this.props.onChange != null) {
            if (Array.isArray(option)) {
                onChange(_.map(option, (type) => type.name));
            }
            else if (option != null) {
                onChange(option.name);
            }
            else {
                onChange(null);
            }
        }
    }

    public render() {
        const {
            types,
            locale,
            selected,
            multiple,
            placeholder,
            placeholderMessage,
            id,
        } = this.props;
        let value: Type[] = [];
        if (Array.isArray(selected)) {
            value = _.map(selected, (name) => _.find(types, ["name", name]));
        }
        else {
            value = [_.find(types, ["name", selected])];
        }
        const props: SelectProps<Type> = {
            getOptionValue: (type) => type.name,
            getOptionLabel: (type) => Localisation.translateMap(type.label, locale),
            isMulti: multiple != null && multiple === true,
            value,
            options: types,
            onChange: this.handleChange.bind(this),
            inputId: id,
        };
        if (placeholder != null) {
            props.placeholder = placeholder;
        }
        if (placeholderMessage != null) {
            props.placeholderMessage = placeholderMessage;
        }
        return (
            <div className="type-select">
                <SelectType {...props}/>
            </div>
        );
    }
}

const ConnectedTypeSelect = compose<Props, OuterProps>(
    withLocale,
    withTypes,
)(TypeSelect);

export {
    TypeSelect as TypeSelectPresenter,
    ConnectedTypeSelect as TypeSelect,
};
